const STYLES = {
    UPLOADED: "bg-neutral-100 text-neutral-700 border-neutral-200",
    PARSING: "bg-amber-50 text-amber-700 border-amber-200",
    NEEDS_REVIEW: "bg-blue-50 text-blue-700 border-blue-200",
    VERIFIED: "bg-indigo-50 text-indigo-700 border-indigo-200",
    APPROVED: "bg-emerald-50 text-emerald-700 border-emerald-200",
    SUPERSEDED: "bg-neutral-100 text-neutral-500 border-neutral-200",
    FAILED: "bg-red-50 text-red-700 border-red-200",
};

const LABELS = {
    UPLOADED: "Uploaded",
    PARSING: "Parsing",
    NEEDS_REVIEW: "Needs review",
    VERIFIED: "Verified",
    APPROVED: "Approved",
    SUPERSEDED: "Superseded",
    FAILED: "Failed",
};

export default function StatusBadge({ status, testid }) {
    const cls = STYLES[status] ?? STYLES.UPLOADED;
    const label = LABELS[status] ?? status;
    return (
        <span
            data-testid={testid ?? `status-${status}`}
            className={`inline-flex items-center rounded-full border px-2 py-0.5 text-[11px] font-medium ${cls}`}
        >
            {label}
        </span>
    );
}
